import Vue from 'vue';

export enum ToastType {
  Success,
  Error,
  Warning,
  Loading
}

export interface IToast {
  message: string;
  type: ToastType;
  timeout: Number | null;
}

interface IToastState {
  toast: IToast | null;
  visible: boolean;
}

class ToastService {
  public state: IToastState = Vue.observable({
    toast: null,
    visible: false
  });

  public get defaultTimeout(): Number {
    return 3000;
  }

  public get toast(): IToast | null {
    return this.state.toast ? this.state.toast : null;
  }

  public get toastVisible(): boolean {
    return this.state.visible;
  }

  public get toastType(): ToastType {
    return this.state.toast ? this.state.toast.type : ToastType.Success;
  }

  public showToast(
    toastMessage?: string,
    toastType?: ToastType,
    timeout?: number
  ): void {
    this.state.toast = {
      message: toastMessage || '',
      type: toastType || ToastType.Success,
      timeout: timeout || this.defaultTimeout
    };
    this.state.visible = true;
  }

  public hideToast(): void {
    this.state.visible = false;
  }
}

export default new ToastService();
